import { render, staticRenderFns } from "./ProcessedByUser.vue?vue&type=template&id=071c3cde&scoped=true"
import script from "./ProcessedByUser.vue?vue&type=script&lang=js"
export * from "./ProcessedByUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071c3cde",
  null
  
)

export default component.exports